<template>
  <page>
    <template slot="content">
    <help-content :title="'歩数がカウントされない(Android)'">
      <template slot="content">
        <div class="text">
          WeRUNアプリは常時バックグラウンドで実行し歩数を計測しています。歩数がカウントされないまたは明らかに少ない場合は以下の設定をご確認ください。
        </div>
        <div class="text">
          <b>計測センサーを変更（WeRUN計測の場合）</b><br>
          独自のヘルス管理機能を搭載している機種（Samsung等）の場合、「メニュー＞アカウント＞計測センサーを選択」で<b>歩数センサーまたは加速度センサー</b>を選択してください。<br><br>
          <b>計測方法を変更</b><br>
          Google Fitアプリがインストールされている場合、Google Fitアプリと歩数を連携することができます。「メニュー＞計測方法切替＞Google Fit＞」で計測方法を変更することができます。<br><br>
          <b>メモリー／バッテリー残量が少ない</b><br>
          メーカーや機種によって、<b>消費電力やメモリの残量等</b>をチェックしバックグラウンドアプリを無効化する機能が搭載されています。歩数が正確に計測できるように、メモリ残量を確認し、<b>不要なプロセスからメモリを解放</b>し、<b>不要なアプリを削除</b>して、目安として<b>20％以上のメモリ残量</b>が残っているようにしてください。<br>
          また、バッテリーの充電を行い、十分なバッテリー残量を確保してください。<br><br>
          <b>バッテリーセーブ機能／アプリを使っている</b><br>
          <b>独自の省電力モード</b>が搭載されている機種（Libero5G A003ZT等）の場合、<b>電池の設定</b>にて<b>アプリの最適化、シーンによる最適化、スマートパワー、その他省電力設定</b>等の設定を<b>すべてオフ</b>にしてください。<br>
          バッテリー消費を抑えるアプリをご利用している場合、歩数計センサーの動作が制限・停止される場合があります。お心当たりのあるアプリを停止してお試しください。<br><br>
          <b>機種依存の場合</b><br>
          一部のメーカーや機種では独自仕様により端末スリープ中や、バックグラウンド動作中の歩数計測が行えません。そのため実際の歩数と大きく異なる場合がございます。<br>
          そのような動作を確認した場合は機種名をお知らせください。<br><br>
          <b>電池の最適化対象に設定されている</b><br>
          Android 6.0以上では<b>電池の最適化</b>機能が追加され、時間が経つとバックグランドアプリが無効化されることがあります。正しく歩数を計測するため、常にバックグラウンドでアプリを実行できるように、<b>電池の最適化機能からWeRUNを対象外</b>にしてください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H24_1.png">
        <img class="picture" src="../assets/images/q_and_a/H24_2.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help24.vue